<template>
  <div class="shortcut-board">
    <div v-for="(row, rowIndex) in displayShortcutRows" :key="rowIndex" class="row">
      <button v-for="item in row" :key="item.key" type="button" class="btn" :class="[
        item.sizeClass,
        item.bgClass,
        { 'is-active': activeKey === item.key },
      ]" :aria-label="item.ariaLabel || item.label" @click="handleShortcutClick(item)">
        {{ item.label }}
      </button>
    </div>
  </div>
</template>

<script>
import { removeToken } from "@/util/token-util.js";

const shortcutRows = [
  [
    {
      key: "search",
      label: "同案由判例简介信息检索",
      sizeClass: "btn-search",
      bgClass: "btn-bg-search",
      needLogin: true,
    },
    {
      key: "qr",
      label: "收款码",
      sizeClass: "btn-qr",
      bgClass: "btn-bg-qr",
    },
    {
      key: "fee",
      label: "收费标准",
      sizeClass: "btn-fee",
      bgClass: "btn-bg-fee",
    },
    {
      key: "agreement",
      label: "用户协议",
      sizeClass: "btn-agreement",
      bgClass: "btn-bg-agreement",
    },
    {
      key: "login",
      label: "登录注册",
      sizeClass: "btn-login",
      bgClass: "btn-bg-login",
    },
    {
      key: "order",
      label: "我的订单",
      sizeClass: "btn-order",
      bgClass: "btn-bg-order",
      needLogin: true,
    },
    {
      key: "message",
      label: "客户留言板",
      sizeClass: "btn-message",
      bgClass: "btn-bg-message",
      needLogin: true,
    },
    {
      key: "feedback",
      label: "投诉入口与反馈",
      sizeClass: "btn-feedback",
      bgClass: "btn-bg-feedback",
      needLogin: true,
    },
  ],
  [
    {
      key: "service",
      label: "客服工作时间",
      sizeClass: "btn-service",
      bgClass: "btn-bg-service",
    },
    {
      key: "privacy",
      label: "隐私政策",
      sizeClass: "btn-privacy",
      bgClass: "btn-bg-privacy",
    },
    {
      key: "honor",
      label: "荣誉展示",
      sizeClass: "btn-honor",
      bgClass: "btn-bg-honor",
    },
    {
      key: "miit",
      label: "工信部网址",
      sizeClass: "btn-miit",
      bgClass: "btn-bg-miit",
      url: "https://beian.miit.gov.cn/",
    },
    {
      key: "license",
      label: "营业执照",
      sizeClass: "btn-license",
      bgClass: "btn-bg-license",
    },
    {
      key: "icp-license",
      label: "ICP许可证",
      sizeClass: "btn-icp-license",
      bgClass: "btn-bg-icp",
    },
    {
      key: "icp-record",
      label: "ICP备案号",
      sizeClass: "btn-icp-record",
      bgClass: "btn-bg-icp-record",
    },
    {
      key: "contact",
      label: "联系我们",
      sizeClass: "btn-contact-btn",
      bgClass: "btn-bg-contact",
      ariaLabel: "联系我们",
    },
  ],
];

export default {
  name: "ShortcutBoard",
  props: {
    activeKey: {
      type: String,
      default: "",
    },
    isLoggedIn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shortcutRows,
    };
  },
  computed: {
    displayShortcutRows() {
      return this.shortcutRows.map((row) =>
        row.map((item) => {
          if (item.key === "login" && this.isLoggedIn) {
            return { ...item, label: "退出登录" };
          }
          return item;
        }),
      );
    },
  },
  methods: {
    handleShortcutClick(item) {
      if (item.url) {
        window.open(item.url, "_blank", "noopener,noreferrer");
        return;
      }

      if (item.needLogin && !this.isLoggedIn) {
        this.$emit("shortcut-click", "login");
        return;
      }

      if (item.key === "login" && this.isLoggedIn) {
        removeToken();
        this.$emit("logout");
        return;
      }

      this.$emit("shortcut-click", item.key);
    },
  },
};
</script>

<style scoped>
.shortcut-board {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 1190px;
  margin-top: 50px;
}

.row {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  border: 0;
  border-radius: 0;
  padding: 0;
  min-width: 0;
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  line-height: 23px;
  box-shadow: none;
  cursor: pointer;
  transition: transform 0.2s ease, filter 0.2s ease;
}

.btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.04);
}

.btn.is-active {
  filter: brightness(1.12) saturate(1.05) contrast(1.08) grayscale(0.12);
  transform: translateY(-1px);
}

.btn:focus {
  outline: none;
}

.btn-bg-search {
  background-image: url("../../../assets/home-confirm/shortcut-board/search.png");
}

.btn-bg-service {
  background-image: url("../../../assets/home-confirm/shortcut-board/service-time.png");
}

.btn-bg-qr {
  background-image: url("../../../assets/home-confirm/shortcut-board/qr-code.png");
}

.btn-bg-fee {
  background-image: url("../../../assets/home-confirm/shortcut-board/fee-standard.png");
}

.btn-bg-feedback {
  background-image: url("../../../assets/home-confirm/shortcut-board/feedback.png");
}

.btn-bg-agreement {
  background-image: url("../../../assets/home-confirm/shortcut-board/agreement.png");
}

.btn-bg-login {
  background-image: url("../../../assets/home-confirm/shortcut-board/login.png");
}

.btn-bg-order {
  background-image: url("../../../assets/home-confirm/shortcut-board/order.png");
}

.btn-bg-message {
  background-image: url("../../../assets/home-confirm/shortcut-board/message.png");
}

.btn-bg-privacy {
  background-image: url("../../../assets/home-confirm/shortcut-board/privacy.png");
}

.btn-bg-honor {
  background-image: url("../../../assets/home-confirm/shortcut-board/honor.png");
}

.btn-bg-icp {
  background-image: url("../../../assets/home-confirm/shortcut-board/icp-license.png");
}

.btn-bg-miit {
  background-image: url("../../../assets/home-confirm/shortcut-board/miit-license.png");
}

.btn-bg-license {
  background-image: url("../../../assets/home-confirm/shortcut-board/business-license.png");
}

.btn-bg-icp-record {
  background-image: url("../../../assets/home-confirm/shortcut-board/icp-record.png");
}

.btn-bg-contact {
  background-image: url("../../../assets/home-confirm/shortcut-board/contact-us.png");
}

.btn-search {
  width: 246px;
  height: 82px;
}

.btn-service {
  width: 154px;
  height: 82px;
}

.btn-qr {
  width: 82px;
  height: 82px;
  margin-left: 12px;
}

.btn-fee {
  width: 112px;
  height: 82px;
  margin-left: 8px;
}

.btn-feedback {
  width: 180px;
  height: 82px;
}

.btn-agreement,
.btn-privacy,
.btn-honor,
.btn-message,
.btn-login,
.btn-order {
  width: 118px;
  height: 82px;
}

.btn-icp-license {
  width: 123px;
  height: 82px;
  margin-left: 8px;
}

.btn-icp-record {
  width: 163px;
  height: 82px;
}

.btn-miit {
  width: 170px;
  height: 82px;
  position: static;
}

.btn-license {
  width: 111px;
  height: 82px;
}

.btn-contact-btn {
  width: 172px;
  height: 82px;
}
</style>
